import React, { useState, useContext, Fragment, useEffect } from "react";
import Page from "components/Page";
import { BuildingContext } from "Context/BuildingProvider";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_SHIFT_CONFIGS } from "lib/buildings";
import { GetShiftConfigsQueryResult } from "generated/graphql";
import PlaybackControl from "Modules/ShiftPlayback/PlaybackControl";
import PlaybackMap from "Modules/ShiftPlayback/PlaybackMap";
import StepperFrame, { StepFrame } from "components/Layout/StepperFrame";
import ShiftPlaybackSlider from "Modules/ShiftPlayback/ShiftPlaybackSlider";
import ConfigForm, { ConfigInput } from "components/Layout/ConfigForm";
import PlaybackLoader from "Modules/ShiftPlayback/PlaybackLoader";
import { AuthContext } from "Firebase/AuthProvider";
import { LinearProgress } from "@material-ui/core";

interface ShiftPlaybackState {
  shiftNumber?: number;
  shiftDate?: string;
}

const DEFAULT_STATE: ShiftPlaybackState = {};

export default function ShiftPlayback() {
  const history = useHistory();
  const [state, setState] = useState(DEFAULT_STATE);
  const { currentBuilding } = useContext(BuildingContext);
  const { setRoute } = useContext(AuthContext);
  useEffect(() => {
    setRoute("Shift Playback");
  }, []);
  const { loading, error, data }: GetShiftConfigsQueryResult = useQuery(
    GET_SHIFT_CONFIGS,
    {
      variables: {
        buildingId: currentBuilding?.Id,
      },
    }
  );
  const handleShiftSelected = (activeStep: number) => {
    if (activeStep === 0) {
    }
  };

  const handleDateChange = (shiftDate: string) => {
    const newDate = shiftDate + "T00:00:00Z";
    setState({ ...state, shiftDate: newDate });
  };

  const handleShiftChange = (shiftNumber: number) => {
    setState({ ...state, shiftNumber });
  };
  if (loading) {
    return <LinearProgress />;
  } else if (error) {
    return <div>{error.message}</div>;
  } else {
    let loaderChildren = <div>error</div>;
    if (state.shiftDate && state.shiftNumber && currentBuilding) {
      loaderChildren = (
        <PlaybackLoader
          shiftNumber={state.shiftNumber}
          shiftDate={state.shiftDate}
          buildingId={currentBuilding.Id}
        />
      );
    }
    const stepFrames: StepFrame[] = [
      {
        label: "Choose Shift",
        children: (
          <PlaybackControl
            shiftConfigs={data?.ShiftConfig}
            handleShiftChange={handleShiftChange}
            handleDateChange={handleDateChange}
          />
        ),
      },
      {
        label: "Play Shift",
        children: loaderChildren,
      },
    ];
    return (
      <Page title="Shift Playback">
        <div>
          <StepperFrame
            stepFrames={stepFrames}
            cancellable={true}
            handleSubmit={() => {}}
            handleNext={handleShiftSelected}
          />
        </div>
      </Page>
    );
  }
}
